import { render, staticRenderFns } from "./EventCreator.vue?vue&type=template&id=cd06fece&"
import script from "./EventCreator.vue?vue&type=script&lang=js&"
export * from "./EventCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports